import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

export type SelectOption<T extends string = string> = { value: T; label: string; disabled?: boolean };

interface SelectProps<T extends string> extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  options: SelectOption<T>[];
  error?: boolean;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps<string>>(function Select(
  { options, error, placeholder, className, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn('ds-select', error && 'error', className)}
      {...rest}
    >
      {placeholder !== undefined && (
        <option value="" disabled hidden>
          {placeholder}
        </option>
      )}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value} disabled={opt.disabled}>
          {opt.label}
        </option>
      ))}
    </select>
  );
});
